import { render, staticRenderFns } from "./zone-announcement.vue?vue&type=template&id=9c1f7fc2&scoped=true"
import script from "./zone-announcement.vue?vue&type=script&lang=js"
export * from "./zone-announcement.vue?vue&type=script&lang=js"
import style0 from "./zone-announcement.vue?vue&type=style&index=0&id=9c1f7fc2&prod&lang=css"
import style1 from "./zone-announcement.vue?vue&type=style&index=1&id=9c1f7fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1f7fc2",
  null
  
)

export default component.exports